// Generated by ReScript, PLEASE EDIT WITH CARE


function getImage(name) {
  var requireImage = (function(name){
        return require(`./images/${name}`).default
      });
  return requireImage(name);
}

function importCss(param) {
  return (require(`./styles/_common_error.scss`));
}

export {
  getImage ,
  importCss ,
  
}
/* No side effect */
